import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';
import { SOCIAL_VERTICAL_ID } from '~/lib/social-vertical';

/**
 * The branded 9:16 "for social", at ORDER time (founder, 14 Oct 2026): the
 * same video the delivery page sells for $16 after delivery (the reel,
 * .server/reel-upsell.ts), offered beside the $35 Social Media Slideshow
 * while the order is being placed. TwtSocialVerticalJob has why it is a job
 * here and a stamp there.
 *
 * Not `social_reel` or anything with "reel" in it: the catalog's service
 * vocabulary reads those as on-site video (lib/schema/order-brain.ts
 * ALIASES), which books a videographer.
 */
export default createPerformableConfig(
  SOCIAL_VERTICAL_ID,
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
    }),
  },
  {
    name: 'Vertical Social Video',
    short:
      'Your listing photos as a branded, full-screen 9:16 video with your name on it, made for Instagram, Facebook, TikTok and YouTube Shorts. (The Social Media Slideshow already includes it, plus an MLS-ready unbranded 16:9.)',
    tenant: TenantId.TWIST_TOURS,
    thumbnail(metadata: Record<string, unknown>) {
      return 'tenant/twt/slideshow/residential.png';
    },
    images: [],
  },
);
